import React from 'react';
import NewsIconWrapper from './NewsIconWrapper';

export default function WorkingConditions(props) {
  return (
    <NewsIconWrapper {...props}>
      <circle cx="16" cy="16" r="16" fill="#FAD6B7"/>
      <path d="M22.6667 7.6665H9.33335C8.41669 7.6665 7.67502 8.4165 7.67502 9.33317L7.66669 24.3332L11 20.9998H22.6667C23.5834 20.9998 24.3334 20.2498 24.3334 19.3332V9.33317C24.3334 8.4165 23.5834 7.6665 22.6667 7.6665ZM16.8334 17.6665H15.1667V15.9998H16.8334V17.6665ZM16.8334 14.3332H15.1667V10.9998H16.8334V14.3332Z" fill="black" fillOpacity="0.54"/>
    </NewsIconWrapper>
  );
}
